<template>
    <div class="ui-content dashboard user-section user-height">
        <v-card class="mx-auto normal-card autohg">
            <div class="data-table-section" ref="infoBox">
                <v-data-table
                    :headers="headers"
                    fixed-header
                    :items="items"
                    hide-default-header
                    hide-default-footer
                    class="elevation-2 cust-table"
                >
                    <template v-slot:header="{ props: { headers } }">
                        <TableHeader
                            :headers="headers"
                            :onHeaderAction="onHeaderAction"
                            :orderBy="orderBy"
                            :onSortChange="onSortChange"
                        />
                    </template>
                    <template v-slot:body="{ items }">
                        <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td>{{ item.name }}</td>
                                <td>{{ item.email }}</td>
                                <td>{{ item.username }}</td>
                                <td class="manage-toggle-icon">
                                    <div class="switch-cust">
                                        <v-switch
                                            v-model="item.active"
                                            inset
                                        ></v-switch>
                                    </div>
                                </td>
                                <td class="blank-80 action-icons manage-edit-icon">
                                    <v-tooltip
                                        v-if="active === 1"
                                        left
                                        content-class="cust-tooltip"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-icon
                                                class="pencil-icon"
                                                v-on="on"
                                                @click="editDEODialog(item)"
                                                >mdi-pencil</v-icon
                                            >
                                        </template>
                                        <span>Edit Name/Email ID</span>
                                    </v-tooltip>
                                    <!-- this worked   -->
                                    <v-tooltip
                                        v-else
                                        left
                                        content-class="cust-tooltip"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-icon
                                                class="delete-icon"
                                                v-on="on"
                                                @click="onDelete(item)"
                                                >mdi-delete</v-icon
                                            >
                                        </template>
                                        <span>Delete DEO</span>
                                    </v-tooltip>
                                </td>
                                <td class="text-left">
                                    <div @click="resetPassword(item)">
                                        <v-icon
                                            title="Reset Password"
                                            class="cp3-reset-pass reset-student-password"
                                            >mdi-lock-reset</v-icon
                                        >
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-data-table>
                <AlertBox
                    width="450px"
                    :onClose="onClose"
                    :component="cComponent"
                    :status="status"
                    :data="selctedUserForEdit"
                />
            </div>
        </v-card>
        <div class="footer-btn">
            <div class="pull-left">
                <v-btn
                    @click="toggleUserStatus"
                    class="right-btn cust-btn"
                    color="primary"
                    >{{
                        active === 1 ? "Deactivated D.E.O.s" : "Active D.E.O.s"
                    }}</v-btn
                >
            </div>
            <div class="pull-right">
                <Pagination
                    :currentPage="currentPage"
                    :totalPage="totalPages"
                    :onPageChange="onPageChange"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
    name: "ManageUsersDEO",
    props: ["updateRouteDetails", "search"],
    data() {
        return {
            headers: [
                { text: "Name", value: "name" },
                { text: "Email ID", value: "email" },
                { text: "User ID", value: "username", hideSort: true },
                { text: "", value: "", hideSort: true, type: "blank", class: "manage-toggle-icon" },
                { text: "", value: "", hideSort: true, type: "blank", class: "manage-edit-icon" },
            ],
            loading: false,
            items: [],
            oldData: [],
            orderBy: {
                field: "name",
                order: "ASC",
            },
            currentPage: 1,
            pageSize: 10,
            totalPages: 1,
            active: 1,
            centers: [],
            selectedCenterId: [],
            status: false,
            selctedUserForEdit: {},
			cComponent: ''
        };
    },
    methods: {
        ...mapActions({
            getSelfSignedUpUsers: "userStore/getSelfSignedUpUsers",
            setUserActiveStatus: "userStore/setUserActiveStatus",
            getCenters: "centerAndBatchStore/getCenters",
            deleteUser: "userStore/deleteUser",
        }),
        toggleUserStatus() {
            this.currentPage = 1;
            this.pageSize = 10;
            this.active = this.active === 1 ? 0 : 1;
            this.updateRouteDetails({
                type: "activateStatus",
                data: { active: this.active, page: 1 },
            });
            this.requesGetSelfSignedUpUsers();
        },
        requesGetSelfSignedUpUsers() {
            let reqData = {
                role_id: this.roleIds.ED,
                is_approved: 1,
                active: this.active,
                orderBy: {
                    field: this.orderBy.field,
                    order: this.orderBy.order,
                },
                pagination: { page: this.currentPage, pageSize: this.pageSize },
                searchQuery: this.search,
            };
            this.$root.showLoader = true;
            this.getSelfSignedUpUsers(reqData)
                .then((response) => {
                    this.items = response.list.map((u) => {
                        u.checked = false;
                        u.canEdit = false;
                        u.center = u.center;
                        return u;
                    });
                    this.setOldData(this.items);
                    this.totalPages = response.pagination.pageCount;
                    this.$root.showLoader = false;
                })
                .catch((err) => {
                    this.$root.showLoader = false;
                });
        },
        onHeaderAction(e) {
            if (e.header && e.header.type === "check") {
                if (e.data) {
                    this.items = this.items.map((u) => {
                        u.checked = e.data.checked;
                        return u;
                    });
                }
            }
        },
        onSortChange() {
            this.requesGetSelfSignedUpUsers();
        },
        onPageChange(e) {
            this.currentPage = e;
            this.requesGetSelfSignedUpUsers();
        },
        requestUpdateUserActiveStatus(user_ids, status, index) {
            let reqData = {
                user_ids: user_ids,
                active: status,
            };
            this.$root.showLoader = true;
            this.setUserActiveStatus(reqData)
                .then((response) => {
                    this.$root.showLoader = false;
                    if (index || index === 0) {
                        this.items.splice(index, 1);
                    } else {
                        this.items = [];
                    }
                    this.setOldData(this.items);
                })
                .catch((err) => {
                    this.$root.showLoader = false;
                });
        },
        setOldData(data) {
            this.oldData = _.cloneDeep(data);
        },
        defaultData() {
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName);
            if (crd) {
                this.searchText = crd.searchText ? crd.searchText : null;
                this.currentPage = crd.tabDetails[crd.selectedTab].page;
                this.orderBy = crd.tabDetails[crd.selectedTab].orderBy;
                this.active = crd.tabDetails[crd.selectedTab].showActivated;
            }
            this.requesGetSelfSignedUpUsers();
        },
        getCenter(selectedCenter) {
            let center = [];
            if (selectedCenter && selectedCenter.length) {
                this.centers.map((m) => {
                    if (selectedCenter.includes(m.value)) {
                        center.push(m.text);
                    }
                });
            }

            return center.join(" ");
        },
        requestGetCenters() {
            this.getCenters()
                .then((response) => {
                    this.loading = false;
                    this.centers = response.map((x) => {
                        let c = {};
                        c.text = x.name;
                        c.value = x.id;
                        return c;
                    });
                    this.centerList = this.centers;
                })
                .catch((err) => {
                    this.loading = false;
                });
        },

        editDEODialog(user) {
           this.cComponent =
                "components/coordinator/users/EditUsers/EditDEO";
            this.selctedUserForEdit = user;
            this.status = true;
        },
        resetPassword(item) {
            this.cComponent = "components/coordinator/ResetStudentPassword";
            this.status = true;
            item.persistent = false;
            this.selctedUserForEdit = item;
        },
        onClose(data) {
            this.status = data.status;
            if (data.reload) {
                this.requesGetSelfSignedUpUsers();
            }
			if (data.is_delete) {
                this.onDeleteDEO(this.selctedUserForEdit);
            }
        },
		onDelete(item) {
            this.cComponent = "components/coordinator/users/ManageUsers/ConfirmationDialog";
			this.selctedUserForEdit = item;
            this.status = true;
        },
        onDeleteDEO(user) {
            if (user) {
                const reqData = {
                    user_id: [user.id],
                };
                this.deleteUser(reqData)
                    .then((response) => {
                        this.$toasted.success(`DEO Deleted Successfully`, {
                            icon: "check_circle",
                        });
                        this.requesGetSelfSignedUpUsers();
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
    },
    mounted() {
        this.requestGetCenters();
        this.defaultData();
    },
    watch: {
        items: {
            deep: true,
            handler(after, before) {
                let changedItem, index;
                after.map((p, idx) => {
                    if (p["active"] !== this.oldData[idx]["active"]) {
                        changedItem = p;
                        index = idx;
                    }
                });
                this.setOldData(after);

                if (changedItem) {
                    this.requestUpdateUserActiveStatus(
                        [changedItem.id],
                        changedItem.active ? true : false,
                        index
                    );
                }
            },
        },
        search() {
            this.requesGetSelfSignedUpUsers();
        },
    },
};
</script>
